import { ViewFactory } from 'wdc-cube-react'

import { HeaderScope, MercadoVetScope } from '../mv_scopes'
import MercadoVetView, { HeaderView } from './mv_view'

export function registerViews(rv = ViewFactory.register) {
    rv(MercadoVetScope, MercadoVetView)
    rv(HeaderScope, HeaderView)
}
